import React from 'react'
import { Link } from 'gatsby'
import { getTagColor } from '../../utils/colorUtils'
import ResizedImage from './ResizedImage'

interface SocietyCardProps {
  title: string
  image?: string
  slug: string
  tags?: string[]
  className?: string
}

const SocietyCard: React.FC<SocietyCardProps> = ({
  title,
  image,
  slug,
  tags = [],
  className = '',
}) => {
  return (
    <Link to={slug} className={`block ${className}`}>
      <div className="card border-0 p-0 hover:shadow-lg transition-shadow h-full">
        {image && (
          <div className="mb-4 relative">
            {/* Use shared ResizedImage for responsive, lazy, optimized loading */}
            <div className="rounded-t-lg rounded-b-none overflow-hidden h-32">
              <ResizedImage
                src={image}
                alt={title}
                sizes="(min-width:1024px) 33vw, (min-width:768px) 50vw, 100vw"
                wrapperStyle={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  paddingTop: '0', // disable aspect padding
                }}
                style={{ objectFit: 'cover' }}
                loading="lazy"
                preload={false}
              />
            </div>

            {tags && tags.length > 0 && (
              <div className="absolute top-2 left-2 flex flex-wrap gap-1">
                {tags.slice(0, 2).map((tag) => (
                  <span
                    key={tag}
                    className={`text-xs px-2 py-1 rounded-full font-medium ${getTagColor(
                      tag
                    )}`}
                  >
                    {tag}
                  </span>
                ))}
                {tags.length > 2 && (
                  <span className="text-xs px-2 py-1 rounded-full font-medium bg-gray-100 text-gray-800">
                    +{tags.length - 2}
                  </span>
                )}
              </div>
            )}
          </div>
        )}

        <div className="px-4 pb-4">
          {!image && tags && tags.length > 0 && (
            <div className="flex flex-wrap gap-1 mb-3">
              {tags.slice(0, 3).map((tag) => (
                <span
                  key={tag}
                  className={`text-xs px-2 py-1 rounded-full font-medium ${getTagColor(
                    tag
                  )}`}
                >
                  {tag}
                </span>
              ))}
              {tags.length > 3 && (
                <span className="text-xs px-2 py-1 rounded-full font-medium bg-gray-100 text-gray-800">
                  +{tags.length - 3}
                </span>
              )}
            </div>
          )}

          <h3 className="text-xl font-semibold mb-3">
            <span className="text-primary">{title}</span>
          </h3>
          <div className="text-primary font-medium">Learn More →</div>
        </div>
      </div>
    </Link>
  )
}

export default SocietyCard